import { createAction, props } from '@ngrx/store';

const getWorkflowData = createAction(
	'[Workflow] Get Workflow ID',
	props<{ apiConstants: any; sid: any; params: any; workflowId: any }>()
);

const getWorkflowInterimData = createAction(
	'[Workflow] Get Workflow Interim data',
	props<{ apiConstants: any; sid: any; params: any; workflowId: any, rolesPayload: any }>()
);

const setWorkflowDT = createAction('[Workflow] Set Workflow', props<{ workflowDT: any }>());

const setWorkflowData = createAction('[Workflow] Set Workflow ID', props<{ workflowData: any }>());

const setWorkflowInterimData = createAction('[Workflow] Set Workflow Interim', props<{ workflowData: any }>());

const setAllActors = createAction('[Workflow] Set Actors', props<{ wfActors: any }>());

const setAllActions = createAction('[Workflow] Set Actions', props<{ wfActions: any }>());

const setPossibleFields = createAction('[Workflow] Set Fields', props<{ dynamicPossibleOptions: any }>());

const setPossibleFieldsForHide = createAction(
	'[Workflow] Set Fields For Hide',
	props<{ dynamicPossibleOptionsForHide: any }>()
);

const getWorkflows = createAction('[Workflow] Get Workflow', props<{ apiConstants: any }>());
const getWorkflowInterims = createAction('[Workflow] Get Workflow Interims', props<{ apiConstants: any , params: any,paginationRequestPayload: any}>());
const getWorkflowsWithSorting = createAction(
	'[Workflow] Get Workflow With Sorting',
	props<{ apiConstants: any; params: any }>()
);
const getWorkflowsWithSearch = createAction(
	'[Workflow] Get Workflow With Search',
	props<{ apiConstants: any; searchFields: any }>()
);

const setWorkflows = createAction('[Workflow] Set Workflow', props<{ workflows: any }>());

const setWorkflowsWithSorting = createAction('[Workflow] Set Workflow With Sorting', props<{ workflows: any }>());

const saveWorkflow = createAction('[Workflow] save Workflow', props<{ apiConstants: any; workflowReqData: any }>());

const deleteWorkflow = createAction('[Workflow] delete Workflow', props<{ apiConstants: any; ids: any }>());

const saveWorkflowStepsOrder = createAction(
	'[Workflow] Save Workflow Steps and Order',
	props<{ apiConstants: any; workflowReqData: any }>()
);

const getWorkflowMail = createAction('[Workflow] Get Workflow Mail', props<{ apiConstants: any; params: any }>());

const setWorkflowMail = createAction('[Workflow] Set Workflow Mail', props<{ workflowMail: any }>());

const saveWorkflowMail = createAction(
	'[Workflow] save Workflow Mail',
	props<{ apiConstants: any; workflowMailData: any }>()
);

const deleteWorkflowMail = createAction('[Workflow] delete Workflow Mail', props<{ apiConstants: any; ids: any }>());

const saveWorkflowOrderSuccess = createAction('[Workflow] Save order success', props<{ results: any }>());

const saveWorkflowOrderFailure = createAction('[Workflow] Save order failed', props<{ error: any }>());

const deleteWorkflowInterim = createAction('[Workflow] delete Workflow Interim', props<{ apiConstants: any; params: any }>());

const deleteWorkflowInterimSuccess = createAction('[Workflow] delete Workflow Interim success', props<{ workflowId: any }>());

const deleteWorkflowInterimFailure = createAction('[Workflow] delete Workflow Interim failure', props<{ error: any }>());

export {
	getWorkflowData,
	getWorkflowInterimData,
	setWorkflowData,
	setWorkflowInterimData,
	setPossibleFieldsForHide,
	setPossibleFields,
	getWorkflowsWithSearch,
	getWorkflowsWithSorting,
	getWorkflows,
	getWorkflowInterims,
	setWorkflowsWithSorting,
	setWorkflows,
	saveWorkflow,
	deleteWorkflow,
	setAllActors,
	setAllActions,
	saveWorkflowStepsOrder,
	getWorkflowMail,
	setWorkflowMail,
	saveWorkflowMail,
	deleteWorkflowMail,
	setWorkflowDT,
	saveWorkflowOrderSuccess,
	saveWorkflowOrderFailure,
	deleteWorkflowInterim,
	deleteWorkflowInterimSuccess,
	deleteWorkflowInterimFailure
};
